import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import CaseStudiesBrowser from "@/components/case-studies/CaseStudiesBrowser";
import FinalCta from "@/components/landing-page/home/FinalCta";
import Reveal from "@/components/ui/Reveal";
import { HAS_PLACEHOLDER_CASE_STUDIES } from "@/lib/data/case-studies";

export default function CaseStudiesPage() {
  return (
    <LandingPageShell>
      <section className="bg-white px-margin-mobile md:px-margin-desktop pt-size-xl pb-size-lg">
        <Reveal className="max-w-[1440px] mx-auto">
          <div className="max-w-4xl">
            <div className="flex items-center gap-base mb-size-sm">
              <span className="w-12 h-[1px] bg-mkt-primary" />
              <span className="font-label-md text-label-md text-mkt-primary uppercase tracking-widest">Case studies</span>
            </div>
            <h1 className="font-display-lg text-[clamp(32px,4.4vw,64px)] leading-[1.1] tracking-[-0.02em] font-bold text-mkt-inarax-black text-balance">
              Real AI capability, built across real workforces.
            </h1>
            <p className="mt-size-md font-body-lg text-body-lg text-mkt-on-surface-variant max-w-3xl">
              How organizations use inaraX to assess their people, personalize learning by role, and validate the
              skills that matter.
            </p>
            {HAS_PLACEHOLDER_CASE_STUDIES ? (
              <p className="mt-size-md inline-block rounded-lg border border-amber-500/40 bg-amber-50 px-size-md py-size-sm font-body-md text-body-md text-amber-900">
                Our first published case studies are on the way. The examples below are illustrative and show the
                kind of programs inaraX runs.
              </p>
            ) : null}
          </div>
        </Reveal>
      </section>

      <section className="bg-mkt-surface px-margin-mobile md:px-margin-desktop py-size-xl">
        <div className="max-w-[1440px] mx-auto">
          <CaseStudiesBrowser />
        </div>
      </section>

      <FinalCta />
    </LandingPageShell>
  );
}
